import React from "react";

function Customers() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="35"
      height="35"
      enableBackground="new 0 0 512 512"
      viewBox="0 0 512 512"
    >
      <path
        fill="#b7d341"
        d="M512 256c0 37.867-8.223 73.813-22.977 106.152-25.222 55.285-69.539 100.016-124.511 125.785a253.364 253.364 0 01-30.887 12.067 250.877 250.877 0 01-36.906 8.766.792.792 0 01-.168.023 254.484 254.484 0 01-18.805 2.289 276.23 276.23 0 01-4.066.313 277.61 277.61 0 01-5.77.324c-3.95.187-7.918.281-11.91.281-4.098 0-8.16-.094-12.203-.293a183.5 183.5 0 01-5.488-.324 279.035 279.035 0 01-4.086-.301 253.502 253.502 0 01-19.254-2.363 252.369 252.369 0 01-9.04-1.621 252.857 252.857 0 01-37.742-10.563 252.203 252.203 0 01-20.71-8.61 226.606 226.606 0 01-6.856-3.355 251.373 251.373 0 01-17.082-9.488c-27.848-16.863-52.215-38.89-71.797-64.75a255.376 255.376 0 01-29.777-50.45C7.848 328.142 0 292.989 0 256 0 114.613 114.613 0 256 0s256 114.613 256 256zm0 0"
        data-original="#ffe152"
      ></path>
      <path
        fill="#2ba1cf"
        d="M205.93 332.215v174.883a252.857 252.857 0 01-37.743-10.563 252.203 252.203 0 01-20.71-8.61 226.606 226.606 0 01-6.856-3.355 251.373 251.373 0 01-17.082-9.488c-27.848-16.863-52.215-38.89-71.797-64.75a255.376 255.376 0 01-29.777-50.45v-27.667c0-32.098 21.797-59.11 51.398-67.02a54.236 54.236 0 013.282-.793 67.01 67.01 0 019.027-1.34 73.596 73.596 0 015.672-.23h45.191c5.047 0 9.969.535 14.715 1.57.27.051.543.114.813.176.796.18 1.601.375 2.382.586.024.012.043.012.063.02a68.997 68.997 0 0121.547 10c18.054 12.527 29.875 33.394 29.875 57.03zm0 0"
        data-original="#2ba1cf"
      ></path>
      <path
        fill="#66baed"
        d="M205.93 332.215v174.883a252.857 252.857 0 01-37.743-10.563 252.203 252.203 0 01-20.71-8.61 226.606 226.606 0 01-6.856-3.355 251.373 251.373 0 01-17.082-9.488c-27.848-16.863-52.215-38.89-71.797-64.75v-78.117c0-32.098 21.797-59.11 51.399-67.02a55.694 55.694 0 013.28-.793 67.197 67.197 0 019.028-1.34 73.618 73.618 0 015.676-.23h15.41c5.047 0 9.969.535 14.715 1.57.27.051.543.114.813.176.796.18 1.601.375 2.382.586.024.012.043.012.063.02a68.997 68.997 0 0121.547 10c18.054 12.527 29.875 33.394 29.875 57.03zm0 0"
        data-original="#66baed"
      ></path>
      <path
        fill="#f2f0ec"
        d="M154.68 264.398l-.164.786-20.758 96.543c-1.992 9.277-10.156 16.003-19.64 16.011h-.352c-9.489-.008-17.649-6.734-19.641-16.011L73.367 265.19l-.164-.793zm0 0"
        data-original="#f2f0ec"
      ></path>
      <path
        fill="#d8d5d0"
        d="M113.941 291.238l-31.238 17.36-9.5-44.2 19.41-11.43m21.328 38.27l31.239 17.36 9.5-44.2-19.41-11.43"
        data-original="#d8d5d0"
      ></path>
      <path
        fill="#cc7a3b"
        d="M20.676 246.11V141.468c0-10.633 1.773-21.051 5.273-30.965C39.047 73.238 74.41 48.19 113.945 48.19c4.899 0 9.785.38 14.535 1.13 21.72 3.394 41.649 14.48 56.098 31.218a93.275 93.275 0 0122.645 60.93v104.64"
        data-original="#cc7a3b"
      ></path>
      <path
        fill="#a35418"
        d="M59.043 145.555c0 37.011 21.676 79.832 33.578 100.554h-71.95V141.47c0-10.63 1.778-21.047 5.274-30.965 13.02-37.05 48.059-62.024 87.32-62.305-28.675.715-54.222 46.723-54.222 97.356zm0 0"
        data-original="#a35418"
      ></path>
      <path
        fill="#eab599"
        d="M138.703 236.105v30.383c0 11.121-7.332 20.524-17.433 23.645a24.662 24.662 0 01-7.325 1.105c-13.672 0-24.75-11.078-24.75-24.75v-30.383zm0 0"
        data-original="#eab599"
      ></path>
      <path
        fill="#f6caae"
        d="M138.703 264.563v1.925c0 11.121-7.332 20.524-17.433 23.645-9.114-2.801-15.965-10.727-17.23-20.422a84.744 84.744 0 0018.73-.953 84.203 84.203 0 0015.933-4.196zm-92.66-78.247c0 11.461-8.371 20.965-19.336 22.727a22.88 22.88 0 01-3.687.297C10.305 209.34 0 199.035 0 186.316c0-12.714 10.305-23.02 23.02-23.02a22.8 22.8 0 013.687.298c10.965 1.761 19.336 11.261 19.336 22.722zm0 0"
        data-original="#f6caae"
      ></path>
      <path
        fill="#eab599"
        d="M46.043 186.316c0 11.461-8.371 20.965-19.336 22.727a85.693 85.693 0 01-3.055-22.727 85.686 85.686 0 013.055-22.722c10.965 1.761 19.336 11.261 19.336 22.722zm0 0"
        data-original="#eab599"
      ></path>
      <path
        fill="#eab599"
        d="M31.25 186.316a8.229 8.229 0 11-16.458.004 8.229 8.229 0 0116.458-.004zm0 0"
        data-original="#eab599"
      ></path>
      <path
        fill="#eab599"
        d="M173.059 156.922v79.133c-12.23 11.675-27.914 19.761-45.364 22.574l-.422.07a84.58 84.58 0 01-13.328 1.035c-47.3 0-85.648-38.347-85.648-85.648v-32.617c0-4.176.297-8.285.875-12.301 20.379 14.656 49.598 13.207 68.215-4.387 6.164-5.824 10.449-12.758 12.87-20.113 1.348 12.879 7.24 25.414 17.68 35.285 12.43 11.734 28.852 17.395 45.122 16.969zm0 0"
        data-original="#eab599"
      ></path>
      <path
        fill="#f6caae"
        d="M173.059 156.922v79.133c-12.23 11.675-27.914 19.761-45.364 22.574l-.422.07c-40.968-6.402-72.304-41.855-72.304-84.613v-32.617c0-.867.015-1.73.047-2.59 15.101 1.547 30.789-3.149 42.37-14.102 6.165-5.82 10.45-12.757 12.872-20.109 1.347 12.879 7.238 25.414 17.68 35.285 12.43 11.734 28.851 17.395 45.12 16.969zm0 0"
        data-original="#f6caae"
      ></path>
      <path
        fill="#eab599"
        d="M159.95 166.852c0-7.86-6.372-14.227-14.227-14.227-7.856 0-14.227 6.367-14.227 14.227m-35.086 0c0-7.86-6.37-14.227-14.226-14.227-7.856 0-14.223 6.367-14.223 14.227"
        data-original="#eab599"
      ></path>
      <path
        fill="#3d4159"
        d="M91.902 172.906c0 5.367-4.351 9.719-9.718 9.719-5.368 0-9.715-4.352-9.715-9.719s4.347-9.715 9.715-9.715c5.367 0 9.718 4.348 9.718 9.715zm63.536 0c0 5.367-4.348 9.719-9.715 9.719-5.368 0-9.715-4.352-9.715-9.719s4.347-9.715 9.715-9.715a9.713 9.713 0 019.714 9.715zm0 0"
        data-original="#3d4159"
      ></path>
      <path
        fill="#eab599"
        d="M123.672 197.371h-19.434a4.192 4.192 0 010-8.383h19.434a4.191 4.191 0 010 8.383zm-9.719 26.519c-7.172 0-14.344-1.796-20.883-5.394a3.809 3.809 0 113.672-6.676c10.778 5.926 23.645 5.926 34.422 0a3.809 3.809 0 113.672 6.676c-6.54 3.598-13.711 5.395-20.883 5.395zm0 0"
        data-original="#eab599"
      ></path>
      <path
        fill="#fff"
        d="M89.922 171.191a4.165 4.165 0 11-8.33-.002 4.165 4.165 0 018.33.002zm64.012 0a4.162 4.162 0 11-8.325 0 4.163 4.163 0 118.325 0zm0 0"
        data-original="#ffffff"
      ></path>
      <path
        fill="#eab599"
        d="M172.25 196.574c0 5.89-4.777 10.668-10.672 10.668-5.89 0-10.668-4.777-10.668-10.668 0-5.894 4.778-10.672 10.668-10.672 5.895 0 10.672 4.778 10.672 10.672zm-95.262 0c0 5.89-4.773 10.668-10.668 10.668-5.89 0-10.668-4.777-10.668-10.668 0-5.894 4.778-10.672 10.668-10.672 5.895 0 10.668 4.778 10.668 10.672zm0 0"
        data-original="#eab599"
      ></path>
      <path
        fill="#bfd5de"
        d="M489.023 330.105v32.047c-25.222 55.286-69.539 100.016-124.511 125.786a253.364 253.364 0 01-30.887 12.066 250.877 250.877 0 01-36.906 8.766.792.792 0 01-.168.023V330.105c0-38.085 29.332-69.332 66.656-72.34a69.55 69.55 0 015.934-.238h47.273c5.59 0 11.031.614 16.258 1.817 32.265 7.375 56.351 36.27 56.351 70.761zm0 0"
        data-original="#bfd5de"
      ></path>
      <path
        fill="#dde8ed"
        d="M489.023 330.105v32.047c-25.222 55.286-69.539 100.016-124.511 125.786a253.364 253.364 0 01-30.887 12.066V330.105c0-40.082 32.508-72.578 72.602-72.578h10.195c40.105 0 72.601 32.496 72.601 72.578zm0 0"
        data-original="#dde8ed"
      ></path>
      <path
        fill="#d3a489"
        d="M321.734 177.465c0 11.992-8.757 21.933-20.226 23.777a24.122 24.122 0 01-3.86.309c-13.304 0-24.086-10.781-24.086-24.086 0-13.305 10.782-24.086 24.086-24.086 1.317 0 2.606.105 3.86.309 11.469 1.847 20.226 11.789 20.226 23.777zm0 0"
        data-original="#d3a489"
      ></path>
      <path
        fill="#f74f4f"
        d="M412.273 283.71l-19.488 31.259-19.488-31.258"
        data-original="#f74f4f"
      ></path>
      <path
        fill="#f74f4f"
        d="M419.004 403.266l-26.219 33.086-26.223-33.086 26.227-96.43zm0 0"
        data-original="#f74f4f"
      ></path>
      <path
        fill="#bf8e75"
        d="M321.734 177.465c0 11.992-8.757 21.933-20.226 23.777a89.59 89.59 0 01-3.195-23.777c0-8.227 1.113-16.2 3.195-23.778 11.469 1.848 20.226 11.79 20.226 23.778zm0 0"
        data-original="#bf8e75"
      ></path>
      <path
        fill="#bf8e75"
        d="M306.258 177.465a8.61 8.61 0 01-8.61 8.61c-4.753 0-8.605-3.856-8.605-8.61s3.852-8.606 8.605-8.606c4.754 0 8.61 3.852 8.61 8.606zm0 0"
        data-original="#bf8e75"
      ></path>
      <path
        fill="#bfd5de"
        d="M392.777 287.238l-32.68 18.164-9.94-46.246 20.304-11.96m22.316 40.042l32.684 18.164 9.941-46.246-20.308-11.96"
        data-original="#bfd5de"
      ></path>
      <path
        fill="#d3a489"
        d="M463.828 177.465c0 11.992 8.758 21.933 20.227 23.777a24.14 24.14 0 003.86.309c13.304 0 24.085-10.781 24.085-24.086 0-13.305-10.781-24.086-24.086-24.086-1.316 0-2.605.105-3.86.309-11.468 1.847-20.226 11.789-20.226 23.777zm0 0"
        data-original="#d3a489"
      ></path>
      <g fill="#bf8e75">
        <path
          d="M463.828 177.465c0 11.992 8.758 21.933 20.227 23.777a89.431 89.431 0 003.195-23.777c0-8.227-1.11-16.2-3.195-23.778-11.47 1.848-20.227 11.79-20.227 23.778zm0 0"
          data-original="#bf8e75"
        ></path>
        <path
          d="M496.523 177.465a8.61 8.61 0 01-17.218 0c0-4.754 3.855-8.606 8.61-8.606a8.607 8.607 0 018.608 8.606zm0 0"
          data-original="#bf8e75"
        ></path>
        <path
          d="M482.398 164.664c0 44.594-32.578 81.59-75.234 88.457a88.526 88.526 0 01-14.383 1.156c-49.496 0-89.613-40.117-89.613-89.613 0-23.418 8.133-58.574 22.84-74.539 16.375-17.777 40.695-15.078 66.773-15.078 4.903 0 9.703.39 14.383 1.16 42.656 6.867 75.234 43.86 75.234 88.457zm0 0"
          data-original="#bf8e75"
        ></path>
        <path
          d="M418.684 229.559v31.785c0 11.636-7.672 21.472-18.243 24.738a25.85 25.85 0 01-7.664 1.156c-14.3 0-25.894-11.593-25.894-25.894v-31.785zm0 0"
          data-original="#bf8e75"
        ></path>
      </g>
      <path
        fill="#d3a489"
        d="M418.684 259.328v2.016c0 11.636-7.672 21.472-18.243 24.738-9.535-2.93-16.703-11.223-18.027-21.367a89.037 89.037 0 0019.602-.996 88.114 88.114 0 0016.668-4.39zm63.714-94.664c0 44.594-32.578 81.59-75.234 88.457-42.652-6.867-75.23-43.863-75.23-88.457 0-27.46 12.351-52.039 31.808-68.48 12.133-10.258 27.035-17.34 43.422-19.98 39.766 6.401 70.785 39 74.793 79.523.293 2.941.441 5.925.441 8.937zm0 0"
        data-original="#d3a489"
      ></path>
      <path
        fill="#bf8e75"
        d="M392.785 208.8c-7.508 0-15.008-1.878-21.848-5.64a3.981 3.981 0 01-1.574-5.414 3.983 3.983 0 015.414-1.57c11.274 6.195 24.739 6.195 36.016 0a3.98 3.98 0 015.41 1.57 3.983 3.983 0 01-1.57 5.414c-6.84 3.762-14.348 5.64-21.848 5.64zm0 0"
        data-original="#bf8e75"
      ></path>
      <path
        fill="#3d4159"
        d="M373.7 159.45c0 5.613-4.552 10.163-10.169 10.163-5.613 0-10.164-4.55-10.164-10.164 0-5.617 4.551-10.168 10.164-10.168a10.166 10.166 0 0110.168 10.168zm58.5 0c0 5.613-4.552 10.163-10.165 10.163-5.617 0-10.168-4.55-10.168-10.164a10.166 10.166 0 0110.168-10.168c5.613 0 10.164 4.551 10.164 10.168zm0 0"
        data-original="#3d4159"
      ></path>
      <path
        fill="#fff"
        d="M371.625 157.652c0 2.407-1.95 4.36-4.355 4.36a4.359 4.359 0 010-8.715 4.357 4.357 0 014.355 4.355zm59 0c0 2.407-1.95 4.36-4.355 4.36a4.359 4.359 0 010-8.715 4.357 4.357 0 014.355 4.355zm0 0"
        data-original="#ffffff"
      ></path>
      <path
        fill="#bf8e75"
        d="M402.95 185.043h-20.333a4.384 4.384 0 110-8.77h20.332a4.384 4.384 0 110 8.77zm0 0"
        data-original="#bf8e75"
      ></path>
      <path
        fill="#bfd5de"
        d="M422.29 327.727h39.065v11.957H422.29zm0 0"
        data-original="#bfd5de"
      ></path>
      <path
        fill="#2a2f4f"
        d="M387.54 49.45c27.147 1.937 48.944 23.866 50.323 51.472l.258 5.183h15.617l8.41 55.93 20.372-6.305-2.735-54.804c-1.445-29-25.43-51.727-54.453-51.617zm0 0"
        data-original="#2a2f4f"
      ></path>
      <path
        fill="#3d4159"
        d="M478.059 27.816c21.617 21.618 21.617 56.668 0 78.286-21.618 21.617-56.668 21.617-78.286 0zm0 0"
        data-original="#3d4159"
      ></path>
      <path
        fill="#3d4159"
        d="M399.773 106.102h-67.937l-8.414 55.933-20.371-6.305 2.73-54.808c1.446-28.992 25.43-51.727 54.457-51.617l98.121.37 12.973 23.348"
        data-original="#3d4159"
      ></path>
      <path
        fill="#2a2f4f"
        d="M398.027 49.45c-27.148 1.937-48.945 23.866-50.324 51.472l-.258 5.183h-15.613l-8.414 55.93-20.371-6.305 2.734-54.804c1.446-29 25.43-51.727 54.453-51.617zm0 0"
        data-original="#2a2f4f"
      ></path>
      <path
        fill="#3d4159"
        d="M364.512 468.742v19.195C331.566 503.372 294.797 512 256 512s-75.578-8.629-108.523-24.074v-19.184c0-37.879 25.714-69.738 60.644-79.078a78.598 78.598 0 013.867-.941 80.932 80.932 0 0110.649-1.567 82.689 82.689 0 016.699-.273h53.309c5.964 0 11.765.629 17.367 1.84.324.062.648.136.96.21.942.22 1.88.45 2.81.7.034.008.042.008.073.02a81.293 81.293 0 0125.415 11.796c21.304 14.778 35.242 39.403 35.242 67.293zm0 0"
        data-original="#3d4159"
      ></path>
      <path
        fill="#66baed"
        d="M304.055 388.723l-.2.93-26.109 121.429a276.23 276.23 0 01-4.066.313 277.61 277.61 0 01-5.77.324c-3.95.187-7.918.281-11.91.281-4.098 0-8.16-.094-12.203-.293a183.5 183.5 0 01-5.488-.324 279.035 279.035 0 01-4.086-.301L208.12 389.664l-.195-.941zm0 0"
        data-original="#66baed"
      ></path>
      <path
        fill="#3d4159"
        d="M277.969 416.422l-21.977 35.242-21.972-35.242"
        data-original="#3d4159"
      ></path>
      <path
        fill="#3d4159"
        d="M273.68 511.395a277.61 277.61 0 01-5.77.324c-3.95.187-7.918.281-11.91.281-4.098 0-8.16-.094-12.203-.293a183.5 183.5 0 01-5.488-.324L256 442.493zm0 0"
        data-original="#3d4159"
      ></path>
      <path
        fill="#2ba1cf"
        d="M255.988 420.395l-36.855 20.48-11.211-52.145 22.898-13.488m25.168 45.153l36.852 20.48 11.21-52.145-22.898-13.488"
        data-original="#2ba1cf"
      ></path>
      <path
        fill="#2a2f4f"
        d="M305.445 459.098h11.692l-20.418 49.672a254.409 254.409 0 01-28.809 2.949l35.871-122.086.274-.91 25.215 8.234zm-61.648 52.609a253.59 253.59 0 01-28.828-2.988l-20.399-49.621h11.692l-23.832-62.141 25.222-8.234.274.91zm0 0"
        data-original="#2a2f4f"
      ></path>
      <path
        fill="#eab599"
        d="M285.2 355.352v35.84c0 13.124-8.653 24.214-20.571 27.898a29.126 29.126 0 01-8.645 1.305c-16.129 0-29.199-13.075-29.199-29.204v-35.84zm0 0"
        data-original="#eab599"
      ></path>
      <path
        fill="#f6caae"
        d="M285.2 388.922v2.273c0 13.121-8.653 24.211-20.571 27.899-10.754-3.309-18.84-12.656-20.332-24.098a100.345 100.345 0 0022.102-1.121 99.53 99.53 0 0018.8-4.953zM175.875 296.61c0 13.519-9.879 24.73-22.813 26.812a27.476 27.476 0 01-4.347.348c-15.004 0-27.164-12.157-27.164-27.16s12.156-27.165 27.164-27.165c1.48 0 2.933.121 4.347.352 12.934 2.082 22.813 13.293 22.813 26.812zm0 0"
        data-original="#f6caae"
      ></path>
      <path
        fill="#eab599"
        d="M175.875 296.61c0 13.519-9.879 24.73-22.813 26.812a101.063 101.063 0 01-3.601-26.813c0-9.28 1.254-18.27 3.601-26.812 12.934 2.082 22.813 13.293 22.813 26.812zm0 0"
        data-original="#eab599"
      ></path>
      <path
        fill="#eab599"
        d="M158.422 296.61c0 5.359-4.348 9.706-9.707 9.706-5.363 0-9.707-4.347-9.707-9.707a9.704 9.704 0 019.707-9.707c5.36 0 9.707 4.344 9.707 9.707zm0 0"
        data-original="#eab599"
      ></path>
      <path
        fill="#f6caae"
        d="M336.105 296.61c0 13.519 9.88 24.73 22.813 26.812 1.41.226 2.867.348 4.348.348 15.004 0 27.164-12.157 27.164-27.16s-12.157-27.165-27.164-27.165c-1.48 0-2.938.121-4.348.352-12.934 2.082-22.813 13.293-22.813 26.812zm0 0"
        data-original="#f6caae"
      ></path>
      <path
        fill="#eab599"
        d="M336.105 296.61c0 13.519 9.88 24.73 22.813 26.812a101.063 101.063 0 003.602-26.813c0-9.28-1.254-18.27-3.602-26.812-12.934 2.082-22.813 13.293-22.813 26.812zm0 0"
        data-original="#eab599"
      ></path>
      <path
        fill="#eab599"
        d="M357.047 243.695v38.48c0 50.29-36.738 92.005-84.84 99.747l-.492.082c-5.117.82-10.367 1.223-15.727 1.223-55.808 0-101.047-45.243-101.047-101.047v-38.485c0-11.75 2.004-23.043 5.707-33.535 13.82-39.328 51.293-67.523 95.34-67.523h.008c5.352 0 10.61.414 15.734 1.222 48.336 7.551 85.317 49.38 85.317 99.836zm0 0"
        data-original="#eab599"
      ></path>
      <path
        fill="#eab599"
        d="M372.973 296.61c0 5.359-4.344 9.706-9.707 9.706-5.36 0-9.707-4.347-9.707-9.707 0-5.363 4.347-9.707 9.707-9.707a9.704 9.704 0 019.707 9.707zm0 0"
        data-original="#eab599"
      ></path>
      <path
        fill="#f6caae"
        d="M357.043 243.695v38.48c0 50.286-36.734 92.005-84.836 99.747l-.496.082c-48.332-7.555-85.305-49.379-85.305-99.828v-38.48c0-50.458 36.98-92.286 85.324-99.837 48.336 7.551 85.313 49.38 85.313 99.836zm0 0"
        data-original="#f6caae"
      ></path>
      <path
        fill="#3d4159"
        d="M234.469 276.29c0 6.331-5.133 11.464-11.461 11.464-6.332 0-11.465-5.133-11.465-11.465 0-6.328 5.133-11.46 11.465-11.46 6.328 0 11.46 5.132 11.46 11.46zm65.972 0c0 6.331-5.132 11.464-11.464 11.464-6.332 0-11.465-5.133-11.465-11.465 0-6.328 5.133-11.46 11.465-11.46s11.464 5.132 11.464 11.46zm0 0"
        data-original="#3d4159"
      ></path>
      <path
        fill="#fff"
        d="M232.133 274.27a4.912 4.912 0 11-9.824-.004 4.912 4.912 0 019.824.004zm66.531 0a4.912 4.912 0 11-9.824-.004 4.912 4.912 0 019.824.004zm0 0"
        data-original="#ffffff"
      ></path>
      <path
        fill="#eab599"
        d="M267.457 300.66h-22.93a4.946 4.946 0 010-9.89h22.93c2.73 0 4.945 2.21 4.945 4.945a4.951 4.951 0 01-4.945 4.945zm-11.465 31.285c-8.46 0-16.926-2.12-24.637-6.363a4.49 4.49 0 01-1.773-6.102 4.5 4.5 0 016.106-1.777c12.714 6.992 27.894 6.992 40.609 0a4.494 4.494 0 016.105 1.777 4.49 4.49 0 01-1.773 6.102c-7.715 4.242-16.176 6.363-24.637 6.363zm0 0"
        data-original="#eab599"
      ></path>
      <path
        fill="#2a2f4f"
        d="M357.047 208.773v39.418h-18.809v-30.87l-135.765-25.227-28.727-5.34v61.437h-18.808V208.77c0-44.938 36.421-81.36 81.351-81.36h39.406c1.07 0 2.14.02 3.211.074 43.434 1.672 78.14 37.422 78.14 81.29zm0 0"
        data-original="#2a2f4f"
      ></path>
      <path
        fill="#3d4159"
        d="M357.047 208.773v39.418h-18.809v-30.87l-135.765-25.227c7.48-35.93 38.652-63.153 76.433-64.61 43.434 1.672 78.14 37.422 78.14 81.29zm0 0"
        data-original="#3d4159"
      ></path>
    </svg>
  );
}

export default Customers;
